import React, { useState, useEffect, useId } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import classes from './styles.module.scss';

const limitTemplate = [
  {
    id: 0,
    count: 15,
  },
  {
    id: 1,
    count: 30,
  },
  {
    id: 2,
    count: 60,
  },
  {
    id: 3,
    count: 100,
  },
];

const Pagination = ({
  onChange, totalPage, page, limit, showLimit, limitCounts,
}) => {
  const uniqId = useId();
  const [show, setShow] = useState(false);

  const handleClickSelectPage = (type, select) => {
    if (type === 'open') {
      setShow(!show);
    } else {
      onChange('limit', select);
      setShow(false);
    }
  };

  const closeMenu = (e) => {
    if (!e.target.closest(`[data-id="select_container${uniqId}"]`)) {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', closeMenu, true);

    return () => {
      window.removeEventListener('click', closeMenu);
    };
  }, []);

  const limitActiveCls = [classes.limitSelectArrow];

  if (show) limitActiveCls.push(classes.activeArrow);

  return (
    <div className={classes.paginationContainer}>
      {totalPage > 1
        ? (
          <ReactPaginate
            previousLabel="<"
            nextLabel=">"
            pageCount={totalPage}
            forcePage={+page}
            marginPagesDisplayed={1}
            pageRangeDisplayed={5}
            onPageChange={(e) => onChange('page', e.selected + 1)}
            containerClassName={`${classes.pagination} ${classes.justifyContentCenter}`}
            pageClassName={classes.pageItem}
            pageLinkClassName={classes.pageLink}
            previousClassName={classes.pageItem}
            previousLinkClassName={classes.pageLink}
            nextClassName={classes.pageItem}
            nextLinkClassName={classes.pageLink}
            breakClassName={classes.pageItem}
            breakLinkClassName={classes.pageLink}
            activeClassName={classes.active}
            disabledClassName={classes.disabled}
          />
        )
        : <div />}

      {!showLimit && (
      <div className={classes.showLimit}>
        <p>Show</p>

        <div
          role="button"
          tabIndex="0"
          data-id={`select_container${uniqId}`}
          onClick={() => handleClickSelectPage('open')}
        >
          <div>{limit}</div>

          <div className={limitActiveCls.join(' ')} />

          {show && (
          <div className={classes.limitSelectCount}>
            {limitCounts.map((d) => (
              +limit !== +d.count
                    && (
                    <div
                      role="button"
                      tabIndex="0"
                      onClick={() => handleClickSelectPage('close', d.count)}
                      key={d.id}
                    >
                      {d.count}
                    </div>
                    )
            ))}
          </div>
          )}
        </div>
      </div>
      )}
    </div>
  );
};

Pagination.propTypes = {
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number,
  page: PropTypes.number,
  limit: PropTypes.number,
  limitCounts: PropTypes.array,
  showLimit: PropTypes.bool,
};

Pagination.defaultProps = {
  totalPage: 1,
  page: 1,
  limit: 15,
  limitCounts: limitTemplate,
  showLimit: false,
};

export default Pagination;
